<template>
  <MetaButton
    data-testid="item-expiration"
    :class="expired ? `text-orange-500` : ``"
    tooltip="Change expiration"
    tooltip-placement="top-start"
    @click.prevent="openShareModalAction(modalProps)"
  >
    <Icon name="general.stopwatch" size="sm" />
    <span>{{ expirationSubheaderMessage }}</span>
  </MetaButton>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { Icon } from '@/storybook/icon';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { useItemExpiration } from '@/modules/viewer/composables/useItemExpiration';
import { useRetention } from '@/modules/viewer/composables/useRetention';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { storeToRefs } from 'pinia';

const { openShareModalAction } = useItemActions();
const { expiresInHuman } = useItemExpiration();
const { expired } = storeToRefs(useViewerItemStore());
const { isItemsRetentionEnabled } = useRetention();

const modalProps = {
  modalProps: {
    selectedTab: '#access-settings',
    expireButtonHighlighter: true,
  },
};

const expirationSubheaderMessage = computed(() => {
  if (expired.value) {
    return `Item has expired`;
  }
  if (expiresInHuman.value === 'never') {
    if (isItemsRetentionEnabled()) {
      return 'Retention policy applies';
    }

    return 'Expires Never';
  }

  return `Expires ${expiresInHuman.value}`;
});
</script>
